import type { ElementType, ReactNode } from 'react';
import { CdHeading, CdText } from '../../atoms/CdTypography';
import { CdFeatureCard, type CdFeatureCardProps } from '../../molecules/CdFeatureCard';
import { cx } from '../../utils';
import styles from './CdFeatureCardGrid.module.scss';

export interface CdFeatureCardGridProps {
  title: string;
  description?: string;
  /** Right-aligned header link (e.g. "View all permit types →"). */
  headerAction?: ReactNode;
  /** Slot between the header and the cards (e.g. a SearchField). */
  search?: ReactNode;
  cards: Omit<CdFeatureCardProps, 'linkAs'>[];
  linkAs?: ElementType;
  className?: string;
}

/** "What are you planning?" – header, search and a responsive grid of FeatureCards. */
export const CdFeatureCardGrid = ({
  title,
  description,
  headerAction,
  search,
  cards,
  linkAs,
  className,
}: CdFeatureCardGridProps) => {
  return (
    <section className={cx(styles.section, className)}>
      <div className={styles.header}>
        <div className={styles.heading}>
          <CdHeading level={2} size="xl">
            {title}
          </CdHeading>
          {description && <CdText tone="secondary">{description}</CdText>}
        </div>
        {headerAction}
      </div>
      {search}
      <ul className={styles.grid}>
        {cards.map((card) => (
          <li key={card.title}>
            <CdFeatureCard {...card} linkAs={linkAs} />
          </li>
        ))}
      </ul>
    </section>
  );
};
